import { Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader, CardTitle } from "@/components/_atoms/card";

export const SidebarAppNoTeamCard = () => {
  const { t } = useTranslation("common");

  return (
    <Card className="mb-4 mt-1 text-sm">
      <CardHeader className="p-4 pb-2">
        <CardTitle className="flex items-center gap-2">
          <Lightbulb className="h-4 w-4 text-yellow-500" aria-hidden="true" />
          {t("sidebar.noTeamCard.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col flex-wrap gap-2 p-4 pt-0 text-xs text-muted-foreground">
        <p>{t("sidebar.noTeamCard.notPartOfTeam")}</p>
        <p>{t("sidebar.noTeamCard.canAskOrCreate")}</p>
      </CardContent>
    </Card>
  );
};
